import { useEditorStore } from '../../../stores/editorStore'

/**
 * O playhead é isolado num componente próprio de propósito.
 *
 * Ele muda ~20 vezes por segundo durante a reprodução; se lesse o tempo dentro do
 * componente da timeline, a timeline inteira — todos os clips — re-renderizaria a cada
 * atualização. Este é o erro clássico que mata a performance de editores web.
 */
export function Playhead({ zoom, offsetTop }: { zoom: number; offsetTop: number }) {
  const playhead = useEditorStore((s) => s.playhead)
  const x = playhead * zoom

  return (
    <div
      className="absolute top-0 bottom-0 pointer-events-none z-30"
      style={{ transform: `translateX(${x}px)` }}
    >
      <div className="absolute top-0 bottom-0 w-px bg-accent" style={{ top: offsetTop }} />
      <div
        className="absolute -translate-x-1/2 w-3 h-3 bg-accent"
        style={{ top: offsetTop - 6, clipPath: 'polygon(50% 100%, 0 0, 100% 0)' }}
      />
    </div>
  )
}
